const BaseConstants = {
  TRUE: "D",
  FALSE: "N"
};
const BooleanToIntegerConstants = {
  TRUE: 1,
  FALSE: 0
};

const UserPreferences = {
  DEFAULT_LANGUAGE: 2
};

const HttpConstants = {
  HTTP_GET_METHOD: "get",
  HTTP_POST_METHOD: "post",
  HTTP_PUT_METHOD: "put",
  HTTP_DELETE_METHOD: "delete",
  JSON_CONTENT_TYPE: "application/json",
  FORM_CONTENT_TYPE: "application/x-www-form-urlencoded",
  MULTIPART_CONTENT_TYPE: "multipart/form-data",
  AUTH_HEADER: "Authorization",
  HTTP_CLIENT_ERROR_CODE: "CLIENT_ERROR",
  HTTP_SERVER_ERROR_CODE: "SERVER_ERROR",
  HTTP_SERVER_ERROR_MESSAGE: "HTTP_ERROR",
  CONTENT_TYPE_HEADER_NAME: "Content-Type",
  SESSION_ID_HEADER: "session-id",
  CSRF_TOKEN_HEADER_NAME: "X-XSRF-TOKEN",
  CSRF_TOKEN_COOKIE_NAME: "XSRF-TOKEN"
};

const AppConstants = {
  BACKOFFICE: "backoffice",
  FRONTOFFICE: "frontoffice",
  PORTAL: "portal"
};

const RouteTypes = {
  ROOT: "root",
  SINGLETON: "singleton",
  TRANSIENT: "transient",
  REGULAR: "regular"
};

const Layouts = {
  DEFAULT: "app",
  BACKOFFICE: "backoffice",
  FRONTOFFICE: "frontoffice",
  MIKPORTAL: "mikportal",
  ROOT: "root",
  APP: "app",
  BASE: "base"
};

const Topics = {
  DEFAULT: "app"
};

const Errors = {
  ERROR: "Error",
  VERIFICATION_REQUIRED: "verification-required",
  LOGIN_ERROR: "login-error",
  INVALID_CODE: "invalid-code",
  FORBIDDEN_STATUS: 403,
  UNAUTHORIZED_STATUS: 401,
  EXPIRED_PASSWORD: 3,
  DB_ERROR_CODE: "db-error"
};

const DateFormats = {
  DATE: "DD.MM.YYYY",
  TIME: "hh:mm",
  ORIGINAL_DATE: "MM.DD.YYYY",
  DATETIME_LOCAL: "DD.MM.YYYY hh:mm:ss"
};

const PositionTypeInsertForm = {
  Fields: {
    ID: "id",
    NAME: "name",
    DATASOURCE: "dataSource",
    VALID: "valid"
  }
};

const MenuItemInsertForm = {
  Fields: {
    ID: "id",
    NAME: "name",
    URL: "url",
    VALID: "valid",
    DESCRIPTION: "description",
    MENU_ITEM_ID: "menuItemId",
    APL_MODE_CODE: "aplModCode",
    RBR: "rbr",
    CHILDREN: "children"
  },
  Constants: {
    MIK_BO: "MIK_BO",
    MIK_PUBLIC: "MIK_PUBLIC"
  }
};

const RequestTypeFormFields = {
  Fields: {
    ID: "id",
    CODE: "code",
    NAME: "name",
    VALID: "valid"
  }
};

const FactFormFields = {
  Fields: {
    ID: "id",
    NAME: "name",
    DATATYPE: "dataType",
    DESCRIPTION: "description",
    SQLEXPRESSION: "sqlExpression"
  }
};
const BusinessRuleFormFields = {
  Fields: {
    ID: "id",
    NAME: "name",
    RULE: "rule",
    DESCRIPTION: "description"
  }
};
const EvaluationTypeFormFields = {
  Fields: {
    ID: "id",
    NAME: "name",
    DESCRIPTION: "description"
  }
};
const RuleGroupFormFields = {
  Fields: {
    ID: "id",
    NAME: "name",
    WEIGHT_THRESHOLD: "weightThreshold",
    DESCRIPTION: "description"
  },
  VALIDATION_RULES: {
    NAME_MAX_LENGTH: 80,
    DESCRIPTION_MAX_LENGTH: 400
  }
};

const RoleTypeInsertForm = {
  Fields: {
    CODE: "code",
    NAME: "name",
    DESCRIPTION: "description",
    VALID: "valid"
  },
  VALIDATION_RULES: {
    CODE_MAX_LENGTH: 30,
    NAME_MAX_LENGTH: 200,
    DESCRIPTION_MAX_LENGTH: 500
  }
};

const TransferDirections = {
  RIGHT: "right",
  LEFT: "left"
};
const ApplicantsAppointmentForm = {
  Fields: {
    POSITION_TYPE_ID: "positionTypeId",
    SOURCE_DATA: "sourceData",
    DESCRIPTION: "description",
    APPOINTMENT_DATE: "appointmentDate",
    APPOINTMENT_DATE_MOMENT: "appointmentDateMoment",
    START_MANDATE: "startMandate",
    START_MANDATE_MOMENT: "startMandateMoment",
    PREDICTED_END: "predictedEnd",
    PREDICTED_END_MOMENT: "predictedEndMoment",
    END_MANDATE: "endMandate",
    END_MANDATE_MOMENT: "endMandateMoment",
    APPOINTMENT_VALID: "appointmentValid"
  }
};

const ApplicantRequestsForm = {
  Fields: {
    ID: "id",
    REPORTING_PERIOD_APPLICANT_ID: "reportingPeriodApplicantId",
    REQUEST_TYPE_CODE: "requestTypeCode",
    NAME: "name",
    CONTENT: "content",
    PRIORITY: "priority",
    READ: "read",
    VALID: "valid",
    VALID_FROM: "validFrom",
    VALID_TO: "validTo"
  },
  VALIDATION_RULES: {
    CODE_MAX_LENGTH: 30,
    NAME_MAX_LENGTH: 80,
    DESCRIPTION_MAX_LENGTH: 500
  }
};

const SourceDataConstants = {
  OPERATOR: "OPERATER",
  APPOINTMENT: "IMENOVANJA"
};

const ReportingTypeInsertForm = {
  Fields: {
    CODE: "code",
    NAME: "name",
    DESCRIPTION: "description",
    VALID: "valid",
    FORM_TYPES_GROUP_CATEGORY_CODE: "formTypesGroupCategoryCode",
    PERIOD: "period",
    PERIOD_MEASURE_UNIT: "periodMeasureUnit",
    REPEATING_PERIOD: "repeatingPeriod",
    PERIOD_OF_REPETITION: "periodOfRepetiton",
    PERIOD_OF_REPETITION_MEASURE_UNIT: "periodOfRepetitonMeasureUnit",
    DATE_FROM: "dateFrom",
    DATE_TO: "dateTo",
    TAG: "tag",
    GRACE_PERIOD_IN_DAYS: "gracePeriodInDays",
    NP_PERIOD_FROM: "npPeriodFrom",
    NP_PERIOD_TO: "npPeriodTo"
  },
  VALIDATION_RULES: {
    CODE_MAX_LENGTH: 30,
    NAME_MAX_LENGTH: 200,
    DESCRIPTION_MAX_LENGTH: 500
  }
};

const ReportingTypePeriodMeasureUnitConstants = {
  DAY: "DAN",
  MONTH: "MJESEC",
  YEAR: "GODINA"
};

const ReportingTypeTag = {
  INITIAL: "POCETNI",
  YEARLY: "GODISNJI"
};

const ReportingPeriodForm = {
  Fields: {
    REPORTING_TYPE_CODE: "reportingTypeCode",
    NAME: "name",
    VALID: "valid",
    NUMBER_OF_REPORTING_PERIOD: "numberOfReportingPeriod",
    STATUS: "status",
    PERIOD_FROM: "periodFrom",
    PERIOD_TO: "periodTo"
  },
  Status: {
    ACTIVE: "Aktivan",
    INACTIVE: "Nekativan"
  }
};

const ReportingPeriodStatusConstants = {
  ACTIVE: "AKTIVAN",
  INACTIVE: "NEAKTIVAN"
};

const ReportingPeriodPermissionForm = {
  Fields: {
    ID: "id",
    ACTION: "action",
    APPLICANT_REPORTING_PERIOD_ID: "applicantReportingPeriodId",
    USER_CODE: "userCode",
    FROM_DATE: "fromDate",
    TO_DATE: "toDate"
  }
};

const ReportingPeriodPermissionAction = {
  EDIT: "UPIS",
  READ: "PREGLED"
};

const FormTypeFormConstants = {
  Fields: {
    CODE: "code",
    NAME: "name",
    VALID: "valid",
    OLD_CODE: "oldCode",
    TAG: "tag"
  },
  VALIDATION_RULES: {
    CODE_MAX_LENGTH: 30,
    NAME_MAX_LENGTH: 80
  }
};

const FormTypesGroupCategoryFormConstants = {
  Fields: {
    CODE: "code",
    NAME: "name",
    VALID: "valid"
  },
  VALIDATION_RULES: {
    CODE_MAX_LENGTH: 30,
    NAME_MAX_LENGTH: 80
  }
};

const CreateSectionFormConstants = {
  Fields: {
    ID: "id",
    ORDER_NUMBER: "orderNumber",
    ORDER_NUMBER_VISIBLE: "orderNumberVisible",
    NAME: "name",
    LABEL: "label",
    LABEL_VISIBLE: "labelVisible",
    FORM_TYPE_CODE: "formTypeCode",
    DESCRIPTION: "description",
    COMMENT: "comment",
    FORM_SECTION_ID: "formSectionId",
    SQL_VALIDATION: "sqlValidation",
    MAX_NUMBER: "maxNumber",
    VALID: "valid",
    REQUIRED: "required",
    PORTAL_AGGREGATE: "portalAggregate"
  },
  VALIDATION_RULES: {
    DESCRIPTION_MAX_LENGTH: 400,
    COMMENT_MAX_LENGTH: 1000,
    SQL_VALIDATION_MAX_LENGTH: 1000
  }
};

const FormSectionQualifierFormConstants = {
  Fields: {
    ORDER_NUMBER: "orderNumber",
    ORDER_NUMBER_VISIBLE: "orderNumberVisible",
    LABEL_VISIBLE: "labelVisible",
    LABEL: "label",
    DESCRIPTION: "description",
    ADDITIONAL_COMMENT: "additionalComment",
    AGGREGATE_FUNCTION: "aggregateFunction",
    ERROR_CODE: "errorCode",
    TOOLTIP: "tooltip",
    REQUIRED: "required"
  },
  VALIDATION_RULES: {
    DESCRIPTION_MAX_LENGTH: 400,
    ADDITIONAL_COMMENT_MAX_LENGTH: 1000,
    AGGREGATE_FUNCTION_MAX_LENGTH: 30,
    TOOLTIP_MAX_LENGTH: 1000
  }
};

const FormSectionDefualtValues = {
  VALID: true,
  ORDER_NUMBER_VISIBLE: true,
  NAME: "segment",
  LABEL: "labela",
  LABEL_VISIBLE: true,
  DESCRIPTION: "Opis",
  COMMENT: "Komentar",
  SQL_VALIDATION: "",
  MAX_NUMBER: 1,
  SUBSECTIONS: [],
  QUALIFIERS: [],
  REQUIRED: false,
  PORTAL_AGGREGATE: false
};

const StorageKeys = {
  USERNAME: "username",
  PASSWORD: "password",
  APPLICANT_ID: "applicantId",
  TWO_FACTOR_AUTH: "twoFactorAuth",
  ROLES: "roles"
};

const PasswordKeys = {
  OLD_PASSWORD: "oldPassword",
  NEW_PASSWORD: "newPassword",
  CONFIRM_NEW_PASSWORD: "confirmNewPassword"
};

const QualifierFormConstants = {
  Fields: {
    CODE: "code",
    NAME: "name",
    VALID: "valid",
    QUALIFIER_DESCRIPTION: "qualifierDescription",
    SQL_VALIDATION: "sqlValidation",
    MAX_NUMBER: "maxNumber",
    INTERNAL_MARK: "internalMark",
    ORDER_NUMBER: "orderNumber",
    ORDER_NUMBER_VISIBLE: "orderNumberVisible",
    LABEL_VISIBLE: "labelVisible",
    FORM_SECTION_QUALIFIER_DESCRIPTION: "formSectionQualifierDescription",
    ADDITIONAL_COMMENT: "additionalComment",
    AGGREGATE_FUNCTION: "aggregateFunction",
    ERROR_CODE: "errorCode",
    TOOLTIP: "tooltip",
    LABEL: "label",
    VISIBLE_PUBLIC: "visiblePublic",
    REQUIRED: "required",
    WIDTH: "width"
  },
  VALIDATION_RULES: {
    DESCRIPTION_MAX_LENGTH: 400,
    SQL_VALIDATION: 2000,
    FORM_SECTION_QUALIFIER_DESCRIPTION_MAX_LENGTH: 400,
    ADDITIONAL_COMMENT_MAX_LENGTH: 1000,
    AGGREGATE_FUNCTION_MAX_LENGTH: 30,
    TOOLTIP_MAX_LENGTH: 1000
  }
};

const QualifierDefaultValues = {
  VALID: true,
  ORDER_NUMBER_VISIBLE: true,
  LABEL_VISIBLE: true,
  VISIBLE_PUBLIC: true,
  QUALIFIER_GROUP_CODE: "MIK_IZVJESTAJI",
  REQUIRED: false
};

const AttributeFormConstants = {
  Fields: {
    CODE: "code",
    ATTRIBUTE_NAME: "attributeName",
    VALID: "valid",
    DESCRIPTION: "description",
    TYPE: "type",
    SQL_VALIDATION: "sqlValidation",
    METHOD_VALIDATION: "methodValidation",
    REQUIRED: "required",
    VALIDATION: "validation",
    ORDER_NUMBER_INSERT_DISPLAY: "orderNumberInsertDisplay",
    QUALIFIER_ATTRIBUTE_NAME: "name",
    VISIBLE: "visible",
    QUALIFIER_CODE: "qualifierCode",
    SHORT_DISPLAY: "shortDisplay",
    LABEL_VISIBLE: "labelVisible"
  },
  VALIDATION_RULES: {
    DESCRIPTION_MAX_LENGTH: 500,
    SQL_VALIDATION_MAX_LENGTH: 2000,
    FIJA_VALIDATION_MAX_LENGTH: 2000
  },
  TYPE_VALUES: {
    ALL_VALUES_AS_ARRAY: [
      "CHAR",
      "NUMBER",
      "DATE",
      "DATE-2",
      "BLOB",
      "CLOB",
      "REFERENCA",
      "REFERENCA-2",
      "INITIAL-DATE",
      "INITIAL-NUMBER",
      "INITIAL-CHAR",
      "INITIAL-REFERENCA",
      "READ-ONLY-REFERENCA",
      "INT",
      "INITIAL-INT"
    ],
    CHAR: "CHAR",
    NUMBER: "NUMBER",
    DATE: "DATE",
    DATE_2: "DATE-2",
    BLOB: "BLOB",
    CLOB: "CLOB",
    REFERENCA: "REFERENCA",
    REFERENCA_2: "REFERENCA-2",
    INITIAL_DATE: "INITIAL-DATE",
    INITIAL_NUMBER: "INITIAL-NUMBER",
    INITIAL_CHAR: "INITIAL-CHAR",
    INITIAL_REFERENCA: "INITIAL-REFERENCA",
    READ_ONLY_REFERENCA: "READ-ONLY-REFERENCA",
    INT: "INT",
    INITIAL_INT: "INITIAL-INT",
    RULES: {
      CHAR_MAX_LENGTH: 1000
    }
  },
  REF_2_DEFAULT_ID: "id"
};

const SystemParametersConstants = {
  VCHAR: "VCHAR",
  NUMBER: "NUMBER",
  INTEGER: "INTEGER",
  DATE: "DATE",
  CLOB: "CLOB",
  BOOLEAN: "BOOLEAN"
};

const SystemParametersInsertForm = {
  Fields: {
    ID: "id",
    PATH: "path",
    DESCRIPTION: "description",
    PARAMETER_TYPE: "parameterType",
    VALUE_VCHAR: "valueVchar",
    VALUE_NUMBER: "valueNumber",
    VALUE_INTEGER: "valueInteger",
    VALUE_DATE: "valueDateTime",
    VALUE_CLOB: "valueClob",
    VALUE_BOOLEAN: "valueBoolean"
  }
};

const AttributeCodebookFormFields = {
  ID: "id",
  CODE: "code",
  LABEL: "label",
  VALUE: "value"
};

const EditFormItemTypes = {
  INPUT: "input",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  SELECT: "select"
};

const AttributeDefaultData = {
  REQUIRED: true,
  VALIDATION: true,
  VISIBLE: true,
  VALID: true
};

const DataGridConstants = {
  PAGE_SIZE: 20,
  MIN_PAGE_SIZE: 10
};

const ModalConstants = {
  WIDTH: 670
};

const InputNumberConstants = {
  MIN_VALUE: 0
};

const SelectComponent = {
  WIDTH: 350
};

const StatusForm = {
  DRAFT: "RADNI",
  SEND: "POSLAN"
};

const FormVersionDocumentFormConstants = {
  FIELDS: {
    NAME: "name",
    DOCUMENT: "document",
    DOCUMENT_RELATION: "documentRelation"
  },
  DOCUMENT_LINK_VALUES_AS_ARRAY: [
    "DODATNA_PROVJERA",
    "UNOS_IZVJESTAJA",
    "REZULTAT_DODATNE_PROVJERE"
  ]
};

const AdditionalCheckForAnnouncement = {
  YES: "D",
  NO: "N"
};

const FormDisplayConstants = {
  COLUMN_WIDTH: 250,
  ACTIONS_COLUMN_WIDTH: 100
};

const SubmitReasons = [{ id: "SAMOINICIJATIVNO" }, { id: "PO ZAHTJEVU" }];
const EvaluationStatuses = [{ id: "NIJE VERIFIKOVAN" }, { id: "VERIFIKOVAN" }];

const LanguageNameCodes = {
  1: "en",
  2: "bs",
  3: "hr",
  4: "sr",
  5: "sr-cyrl"
};

const ReportConstants = {
  AUTOCOMPLETE: {
    APPLICANT_MIN_LENGTH: 3
  }
};

const RoleConstants = {
  MIK_BO: {
    MIK_ADMIN: "MIK_ADMIN",
    MIK_OSOBLJE: "MIK_OSOBLJE",
    MIK_OSOBLJE_PDNS: "MIK_OSOBLJE_PDNS"
  },
  MIK_BO_PDNS_ALLOWED_TABS: ["form", "permissions"]
};

const FormalCheckStatus = {
  ACCEPT: "ZADOVOLJENO",
  REJECT: "NIJE_ZADOVOLJENO"
};

const FormTypesStatuses = {
  OBSOLETE: "ZASTARJELA"
};

const FormTypeConstants = {
  STATUS: {
    PREPARATION: "U PRIPREMI",
    PUBLISHED: "OBJAVLJENA",
    CANCELLED: "PONISTENA"
  }
};

const AdditionalEvaluationResultFormConstants = {
  FIELDS: {
    RESULT: "result"
  }
};

const CodebookTypes = {
  ADDITIONAL_CHECK_STATUS_LIST: "STATUSI_DODATNE_PROVJERE"
};

const RandomSelectionConstants = {
  FIELDS: {
    PERCENTAGE_OF_CANDIDATES: "percentageOfCandidates",
    PERIOD_FROM: "periodFrom",
    PERIOD_TO: "periodTo",
    MIN: "min",
    MAX: "max"
  }
};

const SystemParameterConstants = {
  PERCENTAGE_OF_CANDIDATES: "/DodatnaProvjera/PostotakZaNasumiciOdabir"
};

const Report7ParamBoxConstants = {
  REPORTING_PERIOD_ID: "reportingPeriodId",
  APPLICANT_IDS: "applicantIds",
  FORM_TYPE_CODE: "formTypeCode",
  SELECTED_FORM_STRUCTURE_SECTION_FULLNAMES:
    "selectedFormStructureSectionFullnames"
};

const RegisterApplicantConstants = {
  FIELDS: {
    PARTY_ID: "partyId"
  }
};

export { Topics };
export { Layouts };
export { RouteTypes };
export { UserPreferences };
export { HttpConstants };
export { BaseConstants };
export { Errors };
export { PositionTypeInsertForm };
export { RoleTypeInsertForm };
export { TransferDirections };
export { DateFormats };
export { ApplicantsAppointmentForm };
export { FactFormFields };
export { BusinessRuleFormFields };
export { ReportingTypeInsertForm };
export { ReportingTypePeriodMeasureUnitConstants };
export { ReportingTypeTag };
export { SourceDataConstants };
export { ReportingPeriodForm };
export { ReportingPeriodStatusConstants };
export { FormTypesGroupCategoryFormConstants };
export { CreateSectionFormConstants };
export { FormSectionDefualtValues };
export { StorageKeys };
export { PasswordKeys };
export { DataGridConstants };
export { ModalConstants };
export { InputNumberConstants };
export { AppConstants };
export { ReportingPeriodPermissionForm };
export { ReportingPeriodPermissionAction };
export { FormSectionQualifierFormConstants };
export { QualifierFormConstants };
export { QualifierDefaultValues };
export { AttributeFormConstants };
export { AttributeDefaultData };
export { SelectComponent };
export { FormTypeFormConstants };
export { MenuItemInsertForm };
export { SystemParametersConstants };
export { RequestTypeFormFields };
export { StatusForm };
export { SystemParametersInsertForm };
export { AttributeCodebookFormFields };
export { RuleGroupFormFields };
export { EvaluationTypeFormFields };
export { ApplicantRequestsForm };
export { EditFormItemTypes };
export { FormVersionDocumentFormConstants };
export { AdditionalCheckForAnnouncement };
export { FormDisplayConstants };
export { BooleanToIntegerConstants };
export { SubmitReasons };
export { EvaluationStatuses };
export { LanguageNameCodes };
export { ReportConstants };
export { RoleConstants };
export { FormalCheckStatus };
export { FormTypesStatuses };
export { FormTypeConstants };
export { AdditionalEvaluationResultFormConstants };
export { CodebookTypes };
export { RandomSelectionConstants };
export { SystemParameterConstants };
export { Report7ParamBoxConstants };
export { RegisterApplicantConstants };
